export enum DatabaseQueries {
	GET_COMPANY_STYLES = `
    query CompanyStyles($companyId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $notAssigned: Boolean!, $brandIds: [IdsInput!]!, $categoryIds: [IdsInput!]!, $photographersIds: [IdsInput!]!, $warehousesIds: [IdsInput!]!, $styleGroupIds: [IdsInput!]!, $styleDescriptionIds: [IdsInput!]!, $collectionIds: [IdsInput!]!, $purposeIds: [IdsInput!]!, $teamIds: [IdsInput!]!, $suggestedSeasonIds: [IdsInput!]!) {
        companyStyles(
            companyId: $companyId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            notAssigned: $notAssigned
            brandIds: $brandIds
            categoryIds: $categoryIds
            photographersIds: $photographersIds
            warehousesIds: $warehousesIds
            styleGroupIds: $styleGroupIds
            styleDescriptionIds: $styleDescriptionIds
            collectionIds: $collectionIds
            purposeIds: $purposeIds
            teamIds: $teamIds
            suggestedSeasonIds: $suggestedSeasonIds
        ) {
            nodes {
                total
                datasource {
                    brandId
                    brandName
                    categoryId
                    categoryName
                    modelId
                    styleCode
                    styleName
                    fullName
                    sketchImgPath
                    warehouses {
                        modelId
                        warehouseId
                        warehouseCode
                        warehouseDescription
                        warehouseFullName
                    }
                    ordersInfo {
                        modelId
                        photographerId
                        orderId
                        orderNumber
                        firstName
                        lastName
                        photographerFullName
                    }
                }
            }
        }
    }
    `,
	GET_COMPANY_STYLE_INFO = `
    query CompanyStyleInfo($companyId: Int!, $modelId: Int!) {
        companyStyleInfo(modelId: $modelId, companyId: $companyId) {
            nodes {
                modelId
                styleCode
                styleName
                brand
                category
                collection
                styleGroup
                styleDescription
                label
            }
        }
    }
    `,
	GET_COMPANY_STYLE_DETAILS = `
    query CompanyStyleDetails($modelId: Int!, $paginationPage: Int!, $paginationSize: Int!, $companyId: Int!, $colorIds: [Int!], $sizeGroupIds: [Int!]) {
        companyStyleDetails(
            modelId: $modelId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            companyId: $companyId
            colorIds: $colorIds
            sizeGroupIds: $sizeGroupIds
        ) {
            nodes {
                colorId
                colorName
                sizeGroupId
                sizeGroupName
                defaultColor
                shots {
                    modelId
                    styleCode
                    styleName
                    colorId
                    colorName
                    sizeGroupId
                    shotTypeCode
                    shotTypeName
                    aspectRatioCode
                    aspectRatioName
                    codifiedUsedCode
                    codifiedUsedName
                    mediaFormatCode
                    mediaFormatName
                    defaultColor
                    shotId
                    imgPath
                }
            }
        }
    }
    `,
	GET_WAREHOUSES = `
    query Warehouses($first: Int, $after: String, $search: String, $warehouseIds: [Int!], $companyId: Int!) {
        warehouses(first: $first, after: $after, companyId: $companyId,
            where: { 
                or: [{code: { contains: $search }}, {description: { contains: $search }}]
                id:{ in: $warehouseIds}
            }
            order: { code: ASC, description: ASC }
        ) {
            nodes {
                code
                description
                id
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_STYLE_GROUPS_NO_IDS = `
    query StyleGroups($companyId: Int!, $first: Int, $after: String, $search: String) {
        styleGroups(companyId: $companyId, first: $first, after: $after, 
        where: { name: { contains: $search }}
        order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_STYLE_GROUPS = `
    query StyleGroups($companyId: Int!, $first: Int, $after: String, $search: String, $styleGroupIds: [Int!]) {
        styleGroups(
            companyId: $companyId,
            first: $first, after: $after, 
            where: { name: { contains: $search }, id:{ in: $styleGroupIds}}
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_STYLE_DESCRIPTIONS_NO_IDS = `
    query StyleDescriptions($companyId: Int!, $first: Int, $after: String, $search: String) {
        styleDescriptions(
            companyId: $companyId,
            first: $first, after: $after, 
            where: { name: { contains: $search }}
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_STYLE_DESCRIPTIONS = `
    query StyleDescriptions($companyId: Int!, $first: Int, $after: String, $search: String, $styleDescriptionIds: [Int!]) {
        styleDescriptions(
            companyId: $companyId,
            first: $first, after: $after, 
            where: { name: { contains: $search }, id:{ in: $styleDescriptionIds}}
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_COLLECTIONS_NO_IDS = `
    query Collections($first: Int, $after: String, $search: String, $companyId: Int!) {
        collections(            
            first: $first, after: $after, companyId: $companyId,
            where: { 
                and: [
                    { name: { contains: $search } }
                    { name: { neq: "" } }
                ]
                    companyId: { eq: $companyId }
            }
            order: { name: ASC }
                ) {
            nodes {
                id
                name
                startDate
                endDate
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
	GET_COLLECTIONS = `
    query Collections($collectionIds: [Int!], $companyId: Int!) {
        collections(
            companyId: $companyId,
            where: { id:{ in: $collectionIds}, companyId: { eq: $companyId } }
            order: { name: ASC }
        ) {
            nodes {
                id
                name
                startDate
                endDate
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
	GET_PURPOSES_NO_IDS = `
    query Purposes($companyId: Int!, $first: Int, $after: String, $search: String) {
        purposes(
            companyId: $companyId,
            first: $first, after: $after, 
            where: { name: { contains: $search }}
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_PURPOSES = `
    query Purposes($companyId: Int!, $first: Int, $after: String, $search: String, $purposeIds: [Int!]) {
        purposes(
            companyId: $companyId,
            first: $first, after: $after, 
            where: { name: { contains: $search }, id:{ in: $purposeIds}
            }
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_TEAMS_NO_IDS = `
    query Teams($first: Int, $after: String, $search: String, $companyId: Int!) {
        teams(
            first: $first, after: $after, companyId: $companyId,
            where: { or: [{code: { contains: $search }}, {name: { contains: $search }}]
                brandTeams: {
                    some: { brand: { companyBrands: { some: { companyId: { eq: $companyId } } } } }
                }
            }
            order: { name: ASC }
        ) {
            nodes {
                id
                code
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_TEAMS = `
    query Teams($first: Int, $after: String, $search: String, $teamIds: [Int!], $companyId: Int!) {
        teams(
            first: $first, after: $after, companyId: $companyId,
            where: { or: [{code: { contains: $search }}, {name: { contains: $search }}] id:{ in: $teamIds}
                brandTeams: {
                    some: { brand: { companyBrands: { some: { companyId: { eq: $companyId } } } } }
                }
            }
            order: { name: ASC }
        ) {
            nodes {
                id
                code
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_SUGGESTED_SEASONS_NO_IDS = `
    query SuggestedSeasons($companyId: Int!) {
        suggestedSeasons(
            companyId: $companyId,
            order: { name: ASC }
        ) {
            nodes {
                id
                name
                winter
                fall
                summer
                spring
            }
        }
    }
    `,
	GET_SUGGESTED_SEASONS = `
    query SuggestedSeasons($companyId: Int!, $seasonIds: [Int!]) {
        suggestedSeasons(
            companyId: $companyId,
            where: { id: { in: $seasonIds} }
            order: { name: ASC }
        ) {
            nodes {
                id
                name
                winter
                fall
                summer
                spring
            }
        }
    }
    `
}

